var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"container",staticClass:"container"},[_c('div',{staticClass:"pdfViewer",attrs:{"id":"viewer"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }